import React from 'react';
import ReactDOM from 'react-dom';
/* Redux - React Config */
import {createStore} from 'redux'
import {Provider} from 'react-redux';
import reducer from './store/reducer.js'

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';


const store = createStore(reducer)

ReactDOM.render(
  <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
